'use client';

import React from 'react';

import { Textfit } from '@wwe-portal/ui/components/text-fit';

import { cn } from '@wwe-portal/ui/lib/lib';

export function Countdown({
  children,
  className,
}: Readonly<{ children: React.ReactNode; className?: string }>) {
  if (!children) return null;
  return (
    <div className={cn('relative h-[14px] w-[70px]', className)}>
      <svg
        className="absolute inset-0"
        fill="none"
        height="14"
        viewBox="0 0 69 14"
        width="69"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          clipRule="evenodd"
          d="M10.7503 12.7731C9.64564 13.547 8.30778 14 6.86615 14C3.07408 14 0 10.866 0 7C0 3.13401 3.07408 0 6.86615 0C8.20249 0 9.44966 0.389208 10.5046 1.0625H69V12.7731H10.7503Z"
          fill="#000"
          fillOpacity="0.77"
          fillRule="evenodd"
        />
        <path
          d="M4.043 4.828a.676.676 0 00.042.084h0l.102.174c.222.378.533.91.846 1.413.35.564.742 1.16 1.021 1.44A1.333 1.333 0 107.94 6.055c-.182-.18-.496-.409-.847-.642a.917.917 0 00.824-.912V3.45A3.674 3.674 0 0110.667 7 3.671 3.671 0 017 10.667 3.671 3.671 0 013.333 7v-.002a3.64 3.64 0 01.71-2.17zm2.04-.328c0 .107.019.212.055.311a81.085 81.085 0 00-1.05-.623l-.176-.103H4.91A.608.608 0 004.642 4a.917.917 0 00-1.532-.89A5.468 5.468 0 001.5 7c0 3.033 2.467 5.5 5.5 5.5s5.5-2.467 5.5-5.5c0-3.034-2.467-5.5-5.5-5.5a.917.917 0 00-.917.917V4.5z"
          fill="#fff"
          stroke="#000"
        />
      </svg>
      <div className="absolute inset-0 left-4 font-semibold leading-[14px] text-white">
        <Textfit
          className="flex h-full w-full items-center leading-[14px]"
          max={11}
          mode="single"
        >
          {children}
        </Textfit>
      </div>
    </div>
  );
}
